/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NaturalLanguageEntityMention,
    NaturalLanguageEntityMentionFromJSON,
    NaturalLanguageEntityMentionFromJSONTyped,
    NaturalLanguageEntityMentionToJSON,
} from './NaturalLanguageEntityMention';

/**
 * Google Natural Language API entity object (https://cloud.google.com/natural-language/docs/reference/rest/v1/Entity?hl=ja)
 * @export
 * @interface NaturalLanguageEntity
 */
export interface NaturalLanguageEntity {
    /**
     * The representative name for the entity.
     * @type {string}
     * @memberof NaturalLanguageEntity
     */
    name: string;
    /**
     * The entity type.
     * @type {string}
     * @memberof NaturalLanguageEntity
     */
    type?: NaturalLanguageEntityTypeEnum;
    /**
     * The mentions of this entity in the input document.
     * @type {Array<NaturalLanguageEntityMention>}
     * @memberof NaturalLanguageEntity
     */
    mentions: Array<NaturalLanguageEntityMention>;
}

/**
* @export
* @enum {string}
*/
export enum NaturalLanguageEntityTypeEnum {
    Unknown = 'UNKNOWN',
    Person = 'PERSON',
    Location = 'LOCATION',
    Organization = 'ORGANIZATION',
    Event = 'EVENT',
    WorkOfArt = 'WORK_OF_ART',
    ConsumerGood = 'CONSUMER_GOOD',
    Other = 'OTHER',
    PhoneNumber = 'PHONE_NUMBER',
    Address = 'ADDRESS',
    Date = 'DATE',
    Number = 'NUMBER',
    Price = 'PRICE'
}

export function NaturalLanguageEntityFromJSON(json: any): NaturalLanguageEntity {
    return NaturalLanguageEntityFromJSONTyped(json, false);
}

export function NaturalLanguageEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalLanguageEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'mentions': ((json['mentions'] as Array<any>).map(NaturalLanguageEntityMentionFromJSON)),
    };
}

export function NaturalLanguageEntityToJSON(value?: NaturalLanguageEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'mentions': ((value.mentions as Array<any>).map(NaturalLanguageEntityMentionToJSON)),
    };
}

